import React from 'react';
import Faze from './Faze';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../common/BreadCrumbs';
import Page from '../common/Page';

const FazePage = () => {

    const { t } = useTranslation();

    return (
        <Page>
            <BreadCrumbs stack={[
                {title: t("Domů"), path: "/"},
                {title: t("Historie karet"), path: "/faze"}
            ]} />
            <Faze />
        </Page>
    );
};

export default FazePage;